__turbopack_context__.v({
  "backButton": "styles-module-scss-module__YD6aTa__backButton",
  "carousel": "styles-module-scss-module__YD6aTa__carousel",
  "dateContainer": "styles-module-scss-module__YD6aTa__dateContainer",
  "dateContainerNewsList": "styles-module-scss-module__YD6aTa__dateContainerNewsList",
  "heading": "styles-module-scss-module__YD6aTa__heading",
  "image": "styles-module-scss-module__YD6aTa__image",
  "imageContainer": "styles-module-scss-module__YD6aTa__imageContainer",
  "pagination": "styles-module-scss-module__YD6aTa__pagination",
  "singleBlogTextContainer": "styles-module-scss-module__YD6aTa__singleBlogTextContainer",
  "slide": "styles-module-scss-module__YD6aTa__slide",
  "textContainer": "styles-module-scss-module__YD6aTa__textContainer",
});
